import { inject, Injectable, signal } from "@angular/core";
import { CockpitApi } from "./cockpit.api.service";
import { CockpitLayout, ILayout } from "../cockpitDesigner/cockpitDesigner.models";
import { Device } from "../bots/bots.component";
import { firstValueFrom } from "rxjs";
import { CockpitDesignerStore } from '../cockpitDesigner/cockpitDesigner.service';

type DeviceLayoutResponse = {
  layout: {
    layout:{
      data:{
        dataJSON:ILayout
      }
    }
  }
  device: Device
};

@Injectable({ providedIn: 'root' })


export class CockpitService {

  cockpitApi = inject(CockpitApi);
  cockpitDesignerstore = inject(CockpitDesignerStore)
  readonly cockpitDeviceId = signal<string | null>(null);
  readonly cockpitDevice = signal<Device | null>(null);

  readonly cockpitLayout = signal<CockpitLayout | null>(null);
  

  async loadDeviceLayout(deviceId:string){


  
    const deviceLayout$ = this.cockpitApi.fetchDeviceById(deviceId)
  

    deviceLayout$.subscribe(({device, layout}) => {
      this.cockpitDeviceId.set(deviceId);
      this.cockpitDevice.set(device);
      const transformedLayout = this.cockpitDesignerstore.transformLayout(layout.layout.data.dataJSON)
      this.cockpitLayout.set(transformedLayout);
    });
  }

 async loadDeviceById(id:string) {
    const device = await firstValueFrom(
      this.cockpitApi.fetchDeviceById(id)
    );

    this.cockpitDevice.set(device.device);
  }
}